import React from 'react';
import { connect } from 'react-redux';
import ModalItem from '../../common/ModalItem/ModalItem';
import { Container } from '@material-ui/core';
import './execute.scss';
import YellowButton from '../../common/YellowButton';
import OutlinedButton from '../../common/OutlinedButton';
import * as paymentActions from '../../../store/paymentSlice';
import * as uiActions from '../../../store/uiSlice';
import { completedRoutes, paymentStates } from '../../../common/constants';
import { useHistory } from 'react-router';
import * as tasksActions from '../../../store/tasksSlice';
import { Trans, useTranslation } from 'react-i18next';
import ScoreToRubblesInfo from '../../common/ScroreToRubbleInfo';

function Execute(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const {
    payment, fetchingState, paymentExecute, changeSuccessPopupState,
    changeErrorPopupState, setNeedUpdate,
  } = props;

  if (fetchingState !== 'success') return null;
  if (payment.state === paymentStates.approved) return null;

  const { amount, place: { name, address }, id } = payment;

  const handlePay = () => {
    paymentExecute(id)
      .then(() => {
        setNeedUpdate({ needUpdate: true });
        changeSuccessPopupState({ isOpen: true, data: { amount }, type: 'userPayment' })
      })
      .catch((error) => {
        if (error.status === 401) {
          history.replace(completedRoutes.signUpModalItem, { currentUrl: completedRoutes.userPayment });
        } else if (error.status === 400) {
          changeErrorPopupState({ isOpen: true, error, type: 'paymentExpired' });
        } else {
          console.error(error);
          changeErrorPopupState({ isOpen: true, error, type: 'default' });
        }
      });
  };

  const handleCancel = () => {
    history.replace(completedRoutes.userTasks);
  };

  return (
    <ModalItem>
      <Container className="execute-cnt">
        <h2 className="title">{name}</h2>
        <span className="address">({address})</span>
        <p className="p">
          <Trans i18nKey="userPayment.p3" count={amount}>
            %<span className="rubble green" />
          </Trans>
        </p>
        <p>{' '}</p>
        <div className="score-info"><ScoreToRubblesInfo /></div>
        <YellowButton hidden={false} title={t('userPayment.pay')}
                      handleClick={handlePay}
        />
        <OutlinedButton text={t('common.cancel')} className="execute"
                        onClick={handleCancel}
        />
      </Container>
    </ModalItem>
  );
}

const mapStateToProps = (state) => {
  return {
    payment: state.payments.payment,
    fetchingState: state.payments.fetchingState,
  }
};

const actionCreators = {
  paymentExecute: paymentActions.paymentExecute,
  changeSuccessPopupState: uiActions.changeSuccessPopupState,
  changeErrorPopupState: uiActions.changeErrorPopupState,
  setNeedUpdate: tasksActions.setNeedUpdate,
};

export default connect(mapStateToProps, actionCreators)(Execute);
